/**
 * Pulse placeholders for Battery-Only Core equipment while equipment-preview
 * is in flight. Shapes match Battery manufacturer + Battery storage + Quantity
 * in EquipmentForm.
 */
const SelectPlaceholder = (): JSX.Element => (
  <div className="flex flex-col gap-1.5">
    <div className="h-3 w-28 rounded bg-bp-elevated-2" />
    <div className="flex items-center justify-between rounded-md border border-bp-border-strong bg-bp-elevated px-3 py-2.5">
      <div className="h-4 w-3/5 max-w-[240px] rounded bg-bp-elevated-2" />
      <div className="size-4 shrink-0 rounded bg-bp-elevated-2" />
    </div>
  </div>
)

const CoreEquipmentSkeleton = ({
  label = `Loading equipment…`,
}: {
  label?: string
}): JSX.Element => (
  <div role="status" className="flex animate-pulse flex-col gap-3">
    <SelectPlaceholder />
    <SelectPlaceholder />
    <div className="flex items-center justify-between rounded-md border border-bp-border bg-bp-elevated px-3 py-2.5">
      <div className="h-3 w-20 rounded bg-bp-elevated-2" />
      <div className="h-5 w-6 rounded bg-bp-elevated-2" />
    </div>
    <span className="sr-only">{label}</span>
  </div>
)

export default CoreEquipmentSkeleton
